<template>
  <div id="rpbe">
    <div class="main">
      <h2>{{$t('cmsg.resetpwbe')}}</h2>
      <div class="login_panel">
        <el-row :gutter="15">
          <el-col :span="16">
            <el-form
              ref="reset-email-pwd-form"
              :model="queryObj"
              status-icon
              :validate-on-rule-change="false"
              label-width="130px"
              :show-message="false"
            >
              <p style="text-align: left;">{{$t('cmsg.resetpwbeHint',{user: queryObj.email})}}</p>
              <el-form-item
                :label="$t('cmsg.newPwd')"
                prop="password"
                required
                :error="errors.password"
              >
                <el-input
                  type="password"
                  :placeholder="$t('cmsg.newPwd')"
                  v-model="queryObj.password"
                  @keyup.enter.native="submitF('reset-email-pwd-form')"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('cmsg.newPwdAgain')"
                prop="npassword"
                required
                :error="errors.password"
              >
                <el-input
                  type="password"
                  v-model="queryObj.npassword"
                  :placeholder="$t('cmsg.newPwdAgain')"
                  @keyup.enter.native="submitF('reset-email-pwd-form')"
                ></el-input>
              </el-form-item>
              <!-- <p class="bg-danger" v-if="err">{{err}}</p> -->
              <br>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitF('reset-email-pwd-form')"
                  class="submit_btn"
                  :loading="subLoading"
                >{{$t('cmsg.submit')}}</el-button>
              </el-form-item>
              <p style="text-align: left;">
                {{$t('cmsg.orBackTo')}}
                <router-link :to="{name:'login'}">
                  <el-button type="text">{{$t('cmsg.loginBtn')}}</el-button>
                </router-link>
              </p>
            </el-form>
          </el-col>
          <el-col :span="8">
            <rightSide/>
          </el-col>
        </el-row>
      </div>
    </div>
    <bottomWrapper/>
  </div>
</template>
<script>
import bottomWrapper from "@/views/component/bottom.vue";
import rightSide from "./component/rightSide.vue";
export default {
  components: {
    bottomWrapper,
    rightSide
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.resetpwbe"),
      meta: [
        { vmid: "description", name: "description", content: "Shining3D Login" }
      ]
    };
  },
  data() {
    return {
      err: "",
      queryObj: {
        uuid: "",
        email: "",
        captcha: "",
        password: "",
        npassword: ""
      },
      errors: {
        password: null
      },
      subLoading: false
    };
  },
  methods: {
    submitF(formName) {
      this.$refs[formName].validate(valid => {
        if (valid && this.queryObj.npassword === this.queryObj.password) {
          this.subLoading = true;
          this.$axios
            .post(`/api/f/re`, this.queryObj, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              console.log(res);
              if (res.data && res.data.status === "success") {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                var t = this;
                setTimeout(function() {
                  // window.location = t.$router.resolve({ name: "enLogin" }).href;
                  t.$redirect({ name: "login" });
                }, 3000);
              } else {
                this.err = res.data.result;
                this.errors["password"] = this.$t("cmsg.errField");
                this.subLoading = false;
              }
            })
            .catch(error => {
              console.log("err: ", err);
              this.err = this.$t("cmsg.mting");
              this.subLoading = false;
            });
        } else {
          this.err = this.$t("cmsg.twoPwdMatch");
          this.errors["password"] = this.$t("cmsg.twoPwdMatch");
        }
      });
    }
  },
  mounted() {
    // console.log(this);
    var queryParams = this.$route.query;
    for (var k in queryParams) {
      this.queryObj[k] = queryParams[k];
    }
    console.log("mounted:",pub.cdnUrl);
  }
};
</script>
<style lang="scss">
#rpbe {
  .main {
    background-color: #f7f9fb;
    padding: 15px 0px;
    h2 {
      // min-width: 1200px;
      width: 65vw;
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
      text-align: left;
      margin: 0 auto;
      border-bottom: 5px solid #4b91d1;
      margin-bottom: 15px;
      padding-bottom: 5px;
    }
    .login_panel {
      // min-width: 1200px;
      width: 65vw;
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
      margin: 0 auto;
      .el-form-item {
        .submit_btn {
          width: 100%;
        }
      }
    }
  }
}
</style>
